<template>
    <div>
        <!--
        <button class="btn btn-md btn-block btn-outline-info waves-effect waves-themed" v-on:click="add_prod()" v-if="can_modif_add">
            <span class="fal  fa-eject mr-1"></span>
            {{__t('SELECT_PRODUCT')}}
        </button>
-->
        <b-overlay :show="is_load" rounded="sm">
            <div class="products" v-if="products.length > 0">
                <div class="prod_info" v-for="product in products">
                    <div class="user_profile bg-gradient-primary bd-callout bd-callout-info position-relative mt-2  px-2 p-1">
                        <div class="d-flex flex-row pt-2 pb-1">
                                <span class="status">
                                    <img class="profile-image rounded-circle d-inline-block" :src="product.image">
                                </span>

                                <span class="position-absolute remove" v-on:click.stop.prevent="remove_item(product)" >
                                      <span  class="btn btn-danger btn-sm btn-icon waves-effect waves-themed">
                                          <i class="fal fa-times"></i>
                                      </span>
                                </span>
                                <div class="user_attrib ml-3">
                                    <div class="name d-block fw-700 text-dark">
                                        {{product.title}}
                                    </div>
                                    <div class="company small text-dark">
                                        {{product.price}}
                                    </div>
                                </div>
                        </div>
                        <div class="clr"></div>
                    </div>
                </div>
            </div>
        </b-overlay>

        <product_modal_list
            :selected_ids="active_products_ids"
            :show_trigger="show_trigger"
            :push_trigger_list="push_trigger"
            :is_multiple=true>
        </product_modal_list>

    </div>
</template>

<script>
import product_modal_list from "../../../products/modal_list/product_modal_list.vue";
export default {
    name: "m_products",
    components : {
        product_modal_list,
    },
    props : {
        modif : {
            type : Object
        }
    },
    data() {
        return {
            "show_trigger" : "show_modif_list",
            "push_trigger" : "attach_prod_modif",
            is_load : false,
            attached_products : [],
        }
    },
    created() {
        EventBus.$on(this.push_trigger, this.set_prods);
        this.load_products();

    },

    methods : {

        async load_products() {
            this.is_load = true;
            this.attached_products = [];
            await api.get('/internal/v1/catalog/modifiers/'+ parseInt(this.modif.id) + "/products").then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.attached_products = data.data;
                }
            }).catch(({response}) => {
                this.is_load = false;
            });
        },

        set_prods(prods) {
            console.log("push_products",prods);
        },

        add_prod() {
            EventBus.$emit(this.show_trigger);
        },

        async remove_item(prod) {
            this.is_load = true;
            await api.delete('/internal/v1/catalog/modifiers/'+ parseInt(this.modif.id) + "/product/" + prod.id)
                .then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.attached_products = data.data;
                }
            }).catch(({response}) => {
                this.is_load = false;
            });

        },
    },

    computed : {

        can_modif_add() {
            return this.modif.is_product;
        },

        active_products_ids() {
            return this.products.map(item => {
                return item.prod_id;
            });
        },

        products () {
            if(this.attached_products != null && this.attached_products.length > 0) {
                return this.attached_products.map(item => {
                    item.image = '/product/' + item.prod_id +'/image/' + item.client_id +'/100/100/' +item.client_id  +'.webp'
                    try {
                        let prod = item.product;
                        if(prod != null) {
                            item.title = prod.title;
                            item.price =  prod.price;
                        }
                    }
                    catch (e) {

                    }
                    return item;
                });
            }

            return [];
        }
    }
}
</script>

<style scoped>
    .remove {
        right: 10px;
    }
</style>
